exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".typeahead > span {\n  cursor: pointer;\n  margin-right: 0.3rem;\n}\n.typeahead .el-select-dropdown__item {\n  height: 50px;\n}\n.typeahead .el-select-dropdown__item span {\n  line-height: 0.5;\n}\n.typeahead .el-select-dropdown__item small {\n  line-height: 0.5;\n}\n", ""]);

// exports
